
export class flatDataNews{
  newsTitle: string ='';
  newsSummary:string  = '';
  publishDate:string  = '';
}

export class NewspageContentModel {

  flatData: flatDataNews = new flatDataNews();
}